import * as React from "react";

const SvgIcnFilterUp = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path fill="currentColor" fillRule="nonzero" d="M16 14H8l4-4z" />
        </g>
    </svg>
);

export default SvgIcnFilterUp;
